<template>
  <v-container>
    <v-card
      class="mx-auto set-height"
    >
      <v-card-title>
        <div class="primary--text">
          Profile
        </div>
        <v-spacer />
      </v-card-title>
      <v-col>
        <v-progress-linear
          color="success"
          :class="{hidden: !loading_profile }"
          indeterminate
        />
        <v-divider class="py-2" />
        <v-row
          v-for="info in profile"
          :key="info.personnelidno"
        >
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              v-model="info.personnelidno"
              label="PERSONNELIDNO"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              v-model="info.last_name"
              label="Last Name"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              v-model="info.first_name"
              label="First Name"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              v-model="info.middle_name"
              label="Middle Name"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              v-model="info.nick_name"
              label="Nick Name"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              v-model="info.date_hired"
              label="Date Hired"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              v-model="info.position_code"
              label="Position"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              v-model="info.employment_status"
              label="Status"
              readonly
            />
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-container>
</template>

<script>
  import {
    GetProfile,
  } from '@/graphql/Employee.gql'
  export default {
    data () {
      return {
        // rebuild
        profile: [],
        loading_profile: false,
        skip_profile: true,
      }
    },
    mounted () {
      window.scrollTo(0, 0)
      this.GetProfile()
    },
    methods: {
      GetProfile () {
        this.loading_profile = true
        this.profile = []
        this.skip_profile = false
        this.$apollo.queries.GetProfile.refetch()
      },
    },
    apollo: {
      GetProfile: {
        error (error) {
          this.loading_profile = false
          this.CheckError(error)
        },
        query: GetProfile,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip_profile
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetProfile.status === 'Ok') {
              this.profile = data.GetProfile.data
              this.loading_profile = false
              this.skip_profile = true
            } else if (data.GetProfile.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
          }
        },
      },
    },
  }
</script>
